import React from "react";

import { Box, BoxProps } from "@catchoftheday/cg-components";
import { useTheme } from "@catchoftheday/theme";

import { Placeholder } from "./Placeholder";

type ProductCardPlaceholderProps = BoxProps & {
  uniqueKey: string;
};

export const ProductCardPlaceholder = (props: ProductCardPlaceholderProps) => {
  const theme = useTheme();
  return (
    <Box
      border={`1px solid ${theme.colors.ui.borderColor}`}
      backgroundColor="white"
      {...props}
    >
      <Placeholder uniqueKey={props.uniqueKey} viewBox="0 0 250 450">
        <rect x="0" y="0" width="250" height="200" />

        <rect x="25" y="220" width="200" height="20" />
        <rect x="25" y="250" width="200" height="20" />
        <rect x="100" y="280" width="50" height="20" />
        <rect x="80" y="320" width="90" height="40" />
      </Placeholder>
    </Box>
  );
};
